import ClickOutside from 'v-click-outside';

import {mapActions} from 'vuex';
import {SETTLEMENT_CONFIRMATION_MODAL_EVENT} from '../../../common/constants/constants';

export default {
	directives: {
		ClickOutside: ClickOutside.directive
	},
	data() {
		return {
			visible: false,
			webItems: null,
			address: null
		};
	},
	created() {
		window.EventBus.$on(SETTLEMENT_CONFIRMATION_MODAL_EVENT.OPEN, ({webItems, address}) => {
			this.webItems = webItems;
			this.address = address;
			this.visible = true;
		});
	},
	methods: {
		...mapActions('settlementStore', ['setIsForce']),

		confirm() {
			this.setIsForce(true);
			window.EventBus.$emit(SETTLEMENT_CONFIRMATION_MODAL_EVENT.CONFIRM);
			this.reset();
		},

		reset() {
			this.visible = false;
			this.webItems = null;
			this.address = null;
		},

		cancel() {
			window.EventBus.$emit(SETTLEMENT_CONFIRMATION_MODAL_EVENT.CANCEL);
			this.reset();
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/SET01-settlement/confirmation-modal/confirmation-modal.js